import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, FormaPagamento, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from '@mui/material'
import { selectUser } from '../Redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FormaPagamentoService } from '../../Pages/FormaPagamento/FormaPagamentoService'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    formaPagamento: FormaPagamento[],
    handleUpdateFormaPagamentoList: () => void,
}

type VisibilityState = Record<string, boolean>

type TipoPagamentoMap = {
    [key: string]: string
}

interface RowData {
    id: number,
    descricao: string,
    pacrescimo: number,
    pdesconto: number,
    ordem: number,
    vl_minimo: number,
    tipo: string,
    dt_cadastro: string,
    crediario: string,
}

export const GridFormaPagamento = React.memo(({ formaPagamento, handleUpdateFormaPagamentoList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_formaPag")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_formaPag") || '')
                : {
                    acao: true,
                    descricao: true,
                    pacrescimo: false,
                    pdesconto: false,
                    ordem: false,
                    vl_minimo: true,
                    tipo: true,
                    crediario: true,
                    dt_cadastro: true,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_formaPag")

    let json: any = {
        acao: true,
        descricao: true,
        pacrescimo: false,
        pdesconto: false,
        ordem: false,
        vl_minimo: true,
        tipo: true,
        dt_cadastro: true,

    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_formaPag") || '')
    }
    */

    const [idFormaPag, setIdFormaPag] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [formaPagamentos, setFormaPagamentos] = useState<FormaPagamento[]>([])
    const [nomeFormaPag, setNomeFormaPag] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------    
    useEffect(() => {
        setFormaPagamentos(formaPagamento)
    }, [formaPagamento])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_formaPag", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await FormaPagamentoService.Delete(idFormaPag, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Forma de Pagamento excluído com sucesso`)

                handleUpdateFormaPagamentoList()

                //setFormaPagamentos(await FormaPagamentoService.Filter('', '', ''))
                //setModalShow(false)

            } else {

                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a forma de pagamento. Por favor, tente novamente`)

        }
    }, [idFormaPag])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_formPagamento")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        
        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeFormaPag("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeFormaPag("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },

        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.acao = json.acao
                newColumnVisibility.descricao = json.descricao
                newColumnVisibility.pacrescimo = json.pacrescimo
                newColumnVisibility.pdesconto = json.pdesconto
                newColumnVisibility.ordem = json.ordem
                newColumnVisibility.vl_minimo = json.vl_minimo
                newColumnVisibility.tipo = json.tipo
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    */


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaFormaPagEdit = (id: number) => {
        navigate(`/formaPagto/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const tipoPagamentoMap: TipoPagamentoMap = {
        '01': 'Dinheiro',
        '02': 'Cheque',
        '03': 'Cartão de Crédito',
        '04': 'Cartão de Débito',
        '05': 'Crédito Loja',
        '10': 'Vale Alimentação',
        '11': 'Vale Refeição',
        '12': 'Vale Presente',
        '13': 'Vale Combustível',
        '15': 'Boleto Bancário',
        '16': 'Depósito Bancário',
        '17': 'Pagamento Instantâneo (PIX)',
        '18': 'Transferência bancária, Carteira Digital',
        '19': 'Programa de fidelidade, Cashback, Crédito Virtual',
        '90': 'Sem Pagamento',
        '99': 'Outros',
    }

    function mapTipoPagamento(tipo: string) {

        return (

            <>
                {tipoPagamentoMap[tipo] || <div className='text-red-400'>N/D</div>}
            </>
        )


    }

    const tipoCrediarioMap: TipoPagamentoMap = {
        'S': 'Sim',
        'N': 'Não',

    }

    function mapTipoCrediario(tipo: string) {

        return (

            <>
                {tipoCrediarioMap[tipo] || <div className='text-red-400'>N/D</div>}
            </>
        )


    }

    const colunas = useMemo<MRT_ColumnDef<FormaPagamento>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: false, enableSorting: false, size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                
                const navegar = () => {
                    navegarTelaFormaPagEdit(rowData.id)
                }
                
                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdFormaPag(rowData.id)
                        setNomeFormaPag(rowData.descricao)
                        setModalShow(true)
    
                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }
    
                        let menuFiltro = document.getElementById("divMenuFiltroFormaPag") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsFormaPag") as HTMLDivElement
    
                        if (menuFiltro) {
    
                            menuInputs.classList.add("invisible")
    
                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[390px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0);

                }

                return (
                    <div className={`flex justify-start w-full`}>

                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                            className={`flex items-center justify-center 
                                        text-white transition-all duration-300 
                                        hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                        bg-sky-500`}>
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                        text-white transition-all duration-300 
                                        hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                        bg-red-500 ml-2`} >
                            <FaTrashAlt size="18px" />
                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top'  >
                                <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                            </Tooltip>
                        </button>

                    </div>
                )
            }
        },

        {
            accessorKey: 'descricao', visibleInShowHideMenu: true, header: 'Descrição', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },


            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.descricao ? rowData.descricao : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'pacrescimo', visibleInShowHideMenu: true, header: 'Acrescimo', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },


            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.pacrescimo ? Funcoes.numberFormat(rowData.pacrescimo, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

            }

        },

        {
            accessorKey: 'pdesconto', visibleInShowHideMenu: true, header: 'Desconto', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.pdesconto ? Funcoes.numberFormat(rowData.pdesconto, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

            }

        },

        {
            accessorKey: 'ordem', visibleInShowHideMenu: true, header: 'Ordem', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.ordem ? rowData.ordem : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'vl_minimo', visibleInShowHideMenu: true, header: 'Valor Mínimo', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.vl_minimo ? Funcoes.numberFormat(rowData.vl_minimo, 'currency') : <span className='text-red-400'>N/D</span>}</span>)

            }

        },

        {
            accessorKey: 'tipo', visibleInShowHideMenu: true, header: 'Tipo de Pagamento', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipo: string = rowData.tipo

                return mapTipoPagamento(tipo)
            }
        },

        {
            accessorKey: 'crediario', visibleInShowHideMenu: true, header: 'Crediario', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const crediario: string = rowData.crediario

                return mapTipoCrediario(crediario)
            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

    ], [])


    const table = useMaterialReactTable({
        columns: colunas,
        data: formaPagamentos,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a forma de pagamento - ${nomeFormaPag || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})